import { useState } from "react";
import {
  Grid,
  TextField,
  DataGrid,
  Button,
  MaskedInput,
} from "../../../../../components";
import {
  notification,
  MdfeCiotService,
  MdfeService,
  MdfeContratanteService,
} from "../../../../../services";
import shortid from "shortid";
import { InputErros, value } from "../../../../../helpers";
import { responseErros, formatCnpj, formatCpf } from "../../../../../utils";

const mdfeCiotService = new MdfeCiotService();
const mdfeService = new MdfeService();
const mdfeContratanteService = new MdfeContratanteService();

export default function TabDadosContratacao({
  status,
  contratantes,
  setContratantes,
  ciots,
  setCiots,
  id,
  setLoading,
}) {
  const [contratante, setContratante] = useState({});
  const [numeroCIOT, setNumeroCIOT] = useState(null);
  const [erroNumeroCIOT, setErroNumeroCIOT] = useState(false);
  const [inputErro, setInputErro] = useState([]);
  const inputErros = new InputErros(inputErro, setInputErro);

  const contratantesColunas = [
    {
      field: "cpf",
      headerName: "CPF Contratante",
      valueGetter: (params) => formatCpf(params?.value),
      flex: 200,
    },
    {
      field: "cnpj",
      headerName: "CNPJ Contratante",
      valueGetter: (params) => formatCnpj(params?.value),
      flex: 200,
    },
  ];
  const ciotColunas = [
    {
      field: "numero",
      headerName: "Numero CIOT",
      flex: 200,
    },
  ];

  const cadastrarContratante = async (contratanteAdicao) => {
    setLoading(true);
    const response = await mdfeService.cadastrarContratante(
      id,
      contratanteAdicao
    );
    if (!response.isAxiosError) {
      await buscarContratantes();
      setLoading(false);
      notification.cadastroSucesso();
    } else {
      setLoading(false);
      responseErros(response);
    }
  };

  const cadastrarCiot = async (ciotAdicao) => {
    setLoading(true);
    const response = await mdfeService.cadastrarCiot(id, ciotAdicao);
    if (!response.isAxiosError) {
      await buscarCiots();
      setLoading(false);
      notification.cadastroSucesso();
    } else {
      setLoading(false);
      responseErros(response);
    }
  };

  const onClickAdicionarContratante = () => {
    inputErros.limpar();
    const erros = [];
    let mensagem = null;
    if (!contratante?.cnpj && !contratante?.cpf) {
      erros.push("cnpj", "cpf");
      mensagem = "CNPJ Contratante";
    }
    if (contratante?.cnpj && contratante?.cpf) {
      return notification.alertaGenericos(
        "Informe o CNPJ ou CPF do contratante"
      );
    }
    if (erros.length) {
      return inputErros.gerar(erros, mensagem);
    }
    const contratanteAdicao = {
      id: shortid.generate(),
      cnpj: contratante?.cnpj,
      cpf: contratante?.cpf,
    };
    if (id) {
      cadastrarContratante(contratanteAdicao);
    } else {
      setContratantes([...contratantes, contratanteAdicao]);
    }
    setContratante({});
  };

  const onClickAdicionarCiot = () => {
    if (!numeroCIOT) {
      setErroNumeroCIOT(true);
      return notification.erroValidacao("Número CIOT");
    }
    const ciotAdicao = {
      id: shortid.generate(),
      numero: numeroCIOT,
    };
    if (id) {
      cadastrarCiot(ciotAdicao);
    } else {
      setCiots([...ciots, ciotAdicao]);
    }
    setNumeroCIOT("");
    setErroNumeroCIOT(false);
  };

  const onclickDeletarContratante = (idContratante) => {
    if (id) {
      deletarContratante(idContratante);
    } else {
      setContratantes(
        contratantes.filter((contratante) => contratante.id != idContratante)
      );
    }
  };

  const onclickDeletarCiot = (idCiot) => {
    if (id) {
      deletarCiot(idCiot);
    } else {
      setCiots(ciots.filter((ciot) => ciot.id != idCiot));
    }
  };

  async function buscarCiots() {
    const filter = {
      fatMdfeId: id,
      nonPaginated: true,
    };
    const response = await mdfeCiotService.getAll(filter);
    if (!response.isAxiosError) {
      setCiots(response.data);
    } else {
      responseErros(response);
    }
  }

  async function deletarCiot(idCiot) {
    setLoading(true);
    const response = await mdfeCiotService.deletar(idCiot);
    if (!response.isAxiosError) {
      await buscarCiots();
      setLoading(false);
      notification.deletadoSucesso();
    } else {
      setLoading(false);
      responseErros(response);
    }
  }

  async function buscarContratantes() {
    const filter = {
      fatMdfeId: id,
      nonPaginated: true,
    };
    const response = await mdfeContratanteService.getAll(filter);
    if (!response.isAxiosError) {
      setContratantes(response.data);
    } else {
      responseErros(response);
    }
  }

  async function deletarContratante(idContratante) {
    setLoading(true);
    const response = await mdfeContratanteService.deletar(idContratante);
    if (!response.isAxiosError) {
      await buscarContratantes();
      setLoading(false);
      notification.deletadoSucesso();
    } else {
      setLoading(false);
      responseErros(response);
    }
  }

  const handleChangeInput = (event) => {
    setContratante({
      ...contratante,
      [event.target.name]: event.target.value ? event.target.value : undefined,
    });
  };

  return (
    <Grid container>
      <Grid container xs={6} spacing={2} className="mt-1">
        <Grid item xs={5}>
          <MaskedInput
            id="cpf"
            label="CPF Contratante"
            name="cpf"
            variant="outlined"
            margin="none"
            mask="999.999.999-99"
            onChange={(event) => handleChangeInput(event)}
            value={value.text(contratante?.cpf)}
            error={inputErros.get("cpf")}
          />
        </Grid>
        <Grid item xs={6}>
          <MaskedInput
            id="cnpj"
            label="CNPJ Contratante"
            name="cnpj"
            variant="outlined"
            margin="none"
            mask="**.***.***/****-99"
            onChange={(event) => handleChangeInput(event)}
            value={value.text(contratante?.cnpj)}
            error={inputErros.get("cnpj")}
          />
        </Grid>
        <Grid item xs={1} className="mt-2">
          <Button
            id="buttonAdicionarContratante"
            variant="contained"
            color="success"
            size="small"
            disabled={status != "PENDENTE" ? true : false}
            sx={{
              height: "35px",
              borderRadius: "50%",
              minWidth: "15px",
              boxShadow: "none",
            }}
            onClick={onClickAdicionarContratante}
          >
            <i
              className="ph-bold ph-plus"
              style={{ color: "#fff", fontSize: 15 }}
            ></i>
          </Button>
        </Grid>
        <Grid item xs={12}>
          <DataGrid
            style={{ zIndex: 1 }}
            rows={contratantes}
            columns={contratantesColunas}
            rowCount={contratantes.length}
            onClickDelete={onclickDeletarContratante}
            deleteShow={status != "PENDENTE" ? false : true}
          />
        </Grid>
      </Grid>
      <Grid
        container
        xs={1}
        fullWidth
        className="d-flex justify-content-center"
      >
        <hr className="vr" />
      </Grid>
      <Grid container xs={5} spacing={2} className="mt-2">
        <Grid item xs={9}>
          <TextField
            id="numero"
            name="numero"
            label="Numero CIOT"
            type="text"
            fullWidth
            error={erroNumeroCIOT}
            value={numeroCIOT}
            onChange={(e) => setNumeroCIOT(e.target.value)}
          />
        </Grid>
        <Grid item xs={2} className="mt-2">
          <Button
            id="buttonAdicionarCIOT"
            variant="contained"
            color="success"
            size="small"
            disabled={status != "PENDENTE" ? true : false}
            sx={{
              height: "35px",
              borderRadius: "50%",
              minWidth: "15px",
              boxShadow: "none",
            }}
            onClick={onClickAdicionarCiot}
          >
            <i
              className="ph-bold ph-plus"
              style={{ color: "#fff", fontSize: 15 }}
            ></i>
          </Button>
        </Grid>
        <Grid item xs={12}>
          <DataGrid
            style={{ zIndex: 1 }}
            rows={ciots}
            columns={ciotColunas}
            rowCount={ciots.length}
            onClickDelete={onclickDeletarCiot}
            deleteShow={status != "PENDENTE" ? false : true}
          />
        </Grid>
      </Grid>
    </Grid>
  );
}
